export default "__VITE_ASSET__BrsCHRix__"